import {
	Dialog,
	DialogBackdrop,
	Transition,
	TransitionChild,
} from "@headlessui/react";
import React, { FC, Fragment, useEffect, useState } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonClose from "shared/ButtonClose/ButtonClose";
import dayjs from "dayjs";

import "dayjs/locale/fr";
import { SelectHours } from "./SelectHours";
import { PlusIcon, XCircleIcon } from "@heroicons/react/24/solid";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import Select from "shared/Select/Select";
import { DAY_OFF_TYPES } from "contains/contants";
import Input from "shared/Input/Input";
import Textarea from "shared/Textarea/Textarea";
dayjs.locale("fr");
export interface ModalCommentProps {
	show: boolean;
	timeSlots?: [];
	comment: any;
	onConfirm: (day: any) => void;
	onCloseModal: () => void;
}

const ModalComment: FC<ModalCommentProps> = ({
	comment,
	onConfirm,
	show,
	onCloseModal,
}) => {
	const [newComment, setNewComment] = useState<any>(comment);

	useEffect(() => {
		console.log({ newComment });
	}, []);

	return (
		<Transition appear show={show} as={Fragment}>
			<Dialog
				as="div"
				className="fixed inset-0 z-50"
				onClose={() => {
					onCloseModal();
				}}
			>
				<div className="flex items-stretch md:items-center justify-center h-full text-center md:px-4">
					<TransitionChild
						as={Fragment}
						enter="ease-out duration-300"
						enterFrom="opacity-0"
						enterTo="opacity-100"
						leave="ease-in duration-200"
						leaveFrom="opacity-100"
						leaveTo="opacity-0"
					>
						<DialogBackdrop className="fixed inset-0 bg-black/40 dark:bg-black/70" />
					</TransitionChild>

					{/* This element is to trick the browser into centering the modal contents. */}
					<span className="inline-block align-middle" aria-hidden="true">
						&#8203;
					</span>
					<TransitionChild
						as={Fragment}
						enter="ease-out duration-300"
						enterFrom="opacity-0 scale-95"
						enterTo="opacity-100 scale-100"
						leave="ease-in duration-200"
						leaveFrom="opacity-100 scale-100"
						leaveTo="opacity-0 scale-95"
					>
						<div className="relative inline-flex xl:py-8 xs:w-full max-h-full w-[400px]">
							<div
								className="flex-1 flex overflow-hidden max-h-full p-8 w-full text-left align-middle transition-all transform lg:rounded-2xl bg-white 
				  dark:bg-neutral-900 dark:border dark:border-slate-700 dark:text-slate-100 shadow-xl max-h-[500px]"
							>
								<span className="absolute right-3 top-3 z-50">
									<ButtonClose onClick={onCloseModal} />
								</span>

								<div className="flex-1 overflow-y-auto rounded-xl hiddenScrollbar text-center">
									<p className="text-sm"></p>
									<h3 className="text-xl font-semibold">Commentaire</h3>

									<div className="mt-2">
										<Textarea
											rows={5}
											className={"border-slate-500"}
											value={newComment}
											onChange={({ target }: { target: any }) => {
												setNewComment(target.value);
											}}
										/>
									</div>
									<div className="mt-2">
										<ButtonPrimary
											className="!py-2 !px-4 rounded-xl shadow-none"
											onClick={() => {
												onConfirm(newComment);
											}}
										>
											Valider
										</ButtonPrimary>
									</div>
								</div>
							</div>
						</div>
					</TransitionChild>
				</div>
			</Dialog>
		</Transition>
	);
};

export default ModalComment;
